module.exports = __webpack_public_path__ + "assets/img/Type E (29).8c9e837b.jpg";